import { Link } from 'react-router-dom';

import { ContactForm } from '../components/contact-form';

export default function Contact() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Contact</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Talk to iValue RegTech
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Book a workshop, request a readiness assessment, or align your compliance roadmap with the right technology stack.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/assessment"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Start assessment →
            </Link>
            <Link
              to="/"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              Back to home
            </Link>
          </div>

          <div className="mt-10 grid gap-3 md:grid-cols-3">
            {[
              { t: "Workshops", d: "2–4 hour working session" },
              { t: "Assessments", d: "Evidence-first gap analysis" },
              { t: "Implementations", d: "Deploy + automate controls" },
            ].map((c) => (
              <div key={c.t} className="glass-card sheen p-5">
                <div className="text-sm font-semibold text-text-primary">{c.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{c.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Contact form</div>
            <div className="mt-3 text-sm text-text-secondary">
              Share your requirements — frameworks, timelines, tools, and evidence gaps.
            </div>

            <div className="mt-6">
              <ContactForm title="Talk to iValue" subtitle="We typically respond within 1 business day." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
